
export function getPos(ele: Element | null) {
    if (!ele) {
        return {
            left: 0,
            top: 0,
            width: 0,
            height: 0,
        }
    }
    const rect = ele.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        width: rect.width,
        height: rect.height,
    };
}

export function formatDate(timestampe = 0) {
    if (!timestampe) return '';
    let d = new Date(timestampe);
    return d.toLocaleDateString("en-US", { month: 'short', day: 'numeric' })
}

export function serializeQuery(params: any, prefix?: string): string {
    const query: any = Object.keys(params).map((key) => {
        const value = params[key];

        if (params.constructor === Array)
            key = `${prefix}[]`;
        else if (params.constructor === Object)
            key = (prefix ? `${prefix}[${key}]` : key);

        if (typeof value === 'object')
            return serializeQuery(value, key);
        else
            return `${key}=${encodeURIComponent(value)}`;
    });

    return [].concat.apply([], query).join('&');
}

export function waitUntil(condition: any): Promise<any> {
    let fun = condition
    if (typeof condition == "string") {
        fun = () => {
            //@ts-ignore
            return typeof window[condition] != "undefined";
        }
    }
    if (typeof fun != 'function') {
        fun = () => {
            return !!condition;
        }
    }
    return new Promise((r, j) => {
        let count = 0;
        let h = setInterval(() => {
            count++;
            if (fun()) {
                r(true)
                clearInterval(h);
            }
            if (count > 10) {
                clearInterval(h);
                j();
            }
        }, 500);

    })


}

export function scrollToAnchor(anchorName: string) {
    if (anchorName) {
        // 找到锚点
        let anchorElement = document.getElementById(anchorName);
        // 如果对应id的锚点存在，就跳转到锚点
        if (anchorElement) { anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
    }
}

export const emitDispatchEvent = (name: string, flag: boolean) => {
    let event = new MouseEvent(name || 'onOptionCard', {
        detail: flag ? 1 : 0
    })
    document.body.dispatchEvent(event)
}

export const isShowOption = () => {
    let flag = false;
    ['/websearch'].map(item => {
        if (window.location.href.includes(item)) {
            flag = true
        }
    })
    return flag
}

export const oncopy = (text: any) => {
    let textareaC = document.createElement('textarea');
    textareaC.setAttribute('readonly', 'readonly'); 
    textareaC.value = text;
    document.body.appendChild(textareaC); 
    textareaC.select();
    let res = document.execCommand('copy');
    document.body.removeChild(textareaC);
    return res;
}